import _classCallCheck from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getGlslDifferences } from './glsl_version';
export var Im2ColPackedProgram = function Im2ColPackedProgram(outputShape, inputShape, convInfo) {
  _classCallCheck(this, Im2ColPackedProgram);

  this.variableNames = ['A'];
  this.packedInputs = true;
  this.packedOutput = true;
  this.outputShape = outputShape;
  var filterWidth = convInfo.filterWidth,
      inChannels = convInfo.inChannels,
      strideWidth = convInfo.strideWidth,
      strideHeight = convInfo.strideHeight,
      padInfo = convInfo.padInfo,
      outWidth = convInfo.outWidth,
      dilationWidth = convInfo.dilationWidth,
      dilationHeight = convInfo.dilationHeight,
      dataFormat = convInfo.dataFormat;
  var left = padInfo.left,
      top = padInfo.top;
  var itemsPerBlockRow = inChannels * filterWidth;
  var glsl = getGlslDifferences();
  var isChannelsLast = dataFormat === 'channelsLast';
  var rowDim = isChannelsLast ? 0 : 1;
  var colDim = isChannelsLast ? 1 : 2;
  var unrolled = "";

  for (var row = 0; row <= 1; row++) {
    for (var col = 0; col <= 1; col++) {
      unrolled += "\n          blockIndex = rc.y + ".concat(col, ";\n          pos = rc.x + ").concat(row, ";\n\n          if(blockIndex < ").concat(outputShape[1], " && pos < ").concat(outputShape[0], ") {\n            offsetY = int(blockIndex / (").concat(outWidth, ")) * ").concat(strideHeight, " - ").concat(top, ";\n            d0 = offsetY + ").concat(dilationHeight, " * (pos / ").concat(itemsPerBlockRow, ");\n\n            if(d0 < ").concat(inputShape[rowDim], " && d0 >= 0) {\n\n              offsetX = int(mod(float(blockIndex), ").concat(outWidth, ".) * ").concat(strideWidth, ". - ").concat(left, ".);\n              d1 = offsetX + ").concat(dilationWidth, " * (int(mod(float(pos), ").concat(itemsPerBlockRow, ".) / ").concat(inChannels, ".));\n\n              if(d1 < ").concat(inputShape[colDim], " && d1 >= 0) {\n\n                ch = int(mod(float(pos), ").concat(inChannels, ".));\n\n                if (").concat(isChannelsLast, ") {\n                  innerDims = vec2(d1, ch);\n                  result[").concat(row * 2 + col, "] = getChannel(\n                    getA(d0, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                } else {\n                  innerDims = vec2(d0, d1);\n                  result[").concat(row * 2 + col, "] = getChannel(\n                    getA(ch, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                }\n              }\n            }\n          }\n        ");
    }
  }

  this.userCode = "\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;\n        vec2 innerDims;\n\n        ".concat(unrolled, "\n\n        ").concat(glsl.output, " = result;\n      }\n    ");
};